import React, { Component } from 'react';

import '../css/App.css';

class Footer extends Component {
    render() {

        console.log(this.props.page);
        return (

            <>


                <div style={{ height: 70 }}></div>
                <div className="col-12 step-btn justify-content-center">
                    <div className="container">

                        <div className="row marRight-5 marLeft-5">
                            <div className="col-4 center-align" style={{ textAlign: "center" }} onClick={() => this.props.Push.push('/dashboard')}>
                                {this.props.page === 'dashboard' ?
                                    <img src={require('../images/h_hometab.png')} alt="bulp" style={{ width: 30 }} />
                                    :
                                    <img src={require('../images/tab_home@3x.png')} alt="bulp" style={{ width: 30 }} />
                                }
                            </div>
                            {/* <div className="col-4 center-align" style={{ textAlign: "center" }} onClick={() => this.props.Push.push('/certificate')}>
                                {this.props.page === 'certificate' ?
                                    <i className='fa fa-certificate fa-2x'  />
                                    :
                                    <i className='fa fa-certificate fa-2x'  />
                                }
                            </div> */}

                            <div className="col-4 center-align" style={{ textAlign: "center" }} onClick={() => this.props.Push.push('/search')}>
                                {this.props.page === 'search' ?
                                    <img src={require('../images/h_search.png')} alt="bulp" style={{ width: 30 }} />
                                    :
                                    <img src={require('../images/search.png')} alt="bulp" style={{ width: 30 }} />
                                }
                            </div>

                            <div className="col-4 center-align" style={{ textAlign: "center" }} onClick={() => this.props.Push.push('/resume')}>
                                {this.props.page === 'resume' ?
                                    <img src={require('../images/resume_filled.png')} alt="bulp" style={{ width: 30 }} />
                                    :
                                    <img src={require('../images/resume1@3x.png')} alt="bulp" style={{ width: 30 }} />
                                }
                            </div>

                        </div>
                    </div>
                </div>
            </>
        )
    }
}



export default Footer;